module.exports = __webpack_public_path__ + "img/icon_contact.1f42c64a.png";